import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=530c76a3&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530c76a3",
  null
  
)

export default component.exports